export default __webpack_public_path__ + "static/media/settings-not-selected_skyblue.384bb858.svg";